//Short addresses that always point at the CURRENT page of a recurring event, e.g.
//learning.clubwealth.com/bsm -> /bsm2026. Decided here in code, on purpose, not in the Page
//Builder (Omerson 09/25/2026): a page's url in the builder is its permanent address, and
//nobody has to remember to move "/bsm" from last year's page to this year's.
//
//Each year: point the alias at the new page's url. The alias itself must NOT be any page's
//url in the Page Builder (it would be unreachable); last year's /bsm page was moved to
///bsm2020-archive for that reason (tasks/agenda-page/agenda-bsm2026/migrations/012).
//
//The ?query and the #anchor are kept, so /bsm#tue-0930 lands on the Tuesday 9:30 row
//(pageAnchors.js) and tracking parameters (utm_*) survive.
export const CURRENT_PAGE_ALIASES = {
  '/bsm': '/bsm2026'
};

//"/BSM/" -> "/bsm". Page urls are matched case-insensitively by the backend (latin1 _ci
//column), so the alias is too, and a trailing slash is ignored.
const normalise = (pathname) =>
  (pathname || '').toLowerCase().replace(/\/+$/, '') || '/';

//The page an alias points at, or undefined when `pathname` is not an alias.
export const resolvePageAlias = (pathname) => {
  const target = CURRENT_PAGE_ALIASES[normalise(pathname)];
  return target && normalise(target) !== normalise(pathname)
    ? target
    : undefined;
};

//The full address to go to instead of `location` (target + ?query + #anchor), or
//undefined when no redirect is needed.
export const aliasRedirectTarget = (location) => {
  const target = resolvePageAlias(location?.pathname);
  if (!target) return undefined;
  return target + (location.search || '') + (location.hash || '');
};
